import React, { useState, useEffect } from 'react';
import { TextField, IconButton } from '@material-ui/core';
import { Visibility as VisibilityIcon, VisibilityOff as VisibilityOffIcon } from '@material-ui/icons';
import ErrorMessages from 'components/Global/ErrorMessages';
import mapValidators from 'utility/mapValidators';
import { checkValueLength } from 'utility/checkValidations';
import { useDispatch, useSelector } from 'react-redux';
import { SYSTEM_HANDLE_FORCE_CHECK_VALIDATION } from 'store/key';
import usePrevious from 'hooks/usePrevious';

const PasswordTextField = (props) => {
    const {
        value = '',
        handleChange,
        name,
        label,
        onPressEnter = () => null,
        isValidValue = () => null,
        confirmPasswordNotMatchPassword,
        forceErrorDisplay,
        validators,
        minLength,
        maxLength,
        forceValid,
        ...other
    } = props;

    const forceCheckValidation = useSelector(state => state.system.forceCheckValidation);
    const dispatch = useDispatch();

    const [passwordVisibility, setPasswordVisibility] = useState(false);

    const [errorMessage, setErrorMessage] = useState([]);
    const [isOnBlurTriggered, setOnBlurTrigger] = useState(false);

    const preValidators = usePrevious(validators);
    useEffect(() => {
        if (validators?.toString() !== preValidators?.toString()) {
            onValidation(value);
        };
        // eslint-disable-next-line
    }, [validators]);

    // For 'forceCheckValidation' case
    useEffect(() => {
        if (forceCheckValidation) {
            onValidation(value);
            dispatch({
                type: SYSTEM_HANDLE_FORCE_CHECK_VALIDATION,
                payload: {
                    forceCheckValidation: false
                },
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [forceCheckValidation]);

    // check errors first when input render
    useEffect(() => {
        onValidation(value);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // logic to force error display
    useEffect(() => {
        if (forceErrorDisplay) {
            setOnBlurTrigger(true);
        }
    }, [forceErrorDisplay]);

    useEffect(() => {
        onValidation(value);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [confirmPasswordNotMatchPassword, forceValid]);

    const onValueChange = (e) => {
        handleChange(e);
        onValidation(e.target.value);
        setOnBlurTrigger(true);
    };

    const onValidation = (value) => {
        let tempError = mapValidators(
            value,
            validators,
            { confirmPasswordNotMatchPassword: confirmPasswordNotMatchPassword}
        );
        tempError = [...tempError, ...checkValueLength(value, minLength, maxLength)];

        const valid = forceValid ? true : tempError.length === 0;
        const msg = forceValid ? [] : tempError;

        isValidValue(valid);
        setErrorMessage(msg);
    };

    return (
        <>
            <TextField
                type={passwordVisibility ? 'text' : 'password'}
                autoComplete="new-password"
                onKeyPress={(ev) => {
                    if (ev.key === 'Enter') {
                        // Do code here
                        ev.preventDefault();
                        onPressEnter();
                    }
                }}
                onBlur={() => {
                    setOnBlurTrigger(true);
                }}
                name={name}
                size="small"
                fullWidth
                label={label}
                variant="outlined"
                value={value}
                onChange={onValueChange}
                InputLabelProps={{
                    style: {
                        fontSize: 14,
                    },
                }}
                InputProps={{
                    style: {
                        fontSize: 14,
                    },
                    endAdornment: (
                        <IconButton style={{ padding: 0 }} onClick={() => setPasswordVisibility(!passwordVisibility)}>
                            {passwordVisibility ? <VisibilityIcon /> : <VisibilityOffIcon />}
                        </IconButton>
                    ),
                }}
                {...other}
                error={errorMessage.length > 0 && isOnBlurTriggered}
            />
            <ErrorMessages
                isOnBlurTriggered={isOnBlurTriggered}
                errorMessage={errorMessage}
            />
        </>
    );
};

export default PasswordTextField;
